module.exports = __webpack_public_path__ + "statics/img/2-1.d6a9dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/2-1.png
// module id = rVBG
// module chunks = 1